<template>
  <!--页面加载动画-->
  <div class="items">
    <div class="items-wrap">
      <span class="lables">手机号</span>
      <div class="from-right">
        <input
          type="tel"
          class="input-text tellCode"
          v-model="tell"
          :readonly="disabled"
          @on-change="tellhandle"
          placeholder="请输入您的手机号"
        />
        <i class="iconfont iconfabiaowenzhang"></i>
      </div>
    </div>
    <div class="items-wrap">
      <span class="lables">验证码</span>
      <div class="from-right">
        <input
          type="text"
          class="input-text veryNumber"
          @blur="veryhandle"
          placeholder="请输入验证码"
        />
        <span @click="getVery" :class="'veryTxt status'+status">{{veryTxt?veryTxt+"秒后重新获取":"获取验证码"}}</span>
      </div>
    </div>
    <p v-if="errMsg" class="bank-info">{{errMsg}}</p>
  </div>
</template>

<script>
var timor;
export default {

  data() {
    return {
      tell: "", //手机号
      very: "", //验证码
      disabled: false, //手机号是否禁止修改
      status: 0, //验证码状态
      hasSendVery:false,//短险是否发送成功
      veryTxt: "",
      timor:null,
      params:null,//获取验证码参数
      errMsg:"",//错误提示
    };
  },
  props: ["selectData"],
  mounted() {
    if (this.selectData.defaultTell) {
      this.status = 1;
      this.tell = this.selectData.defaultTell;
    }
    if (this.selectData.readOnly) {
      this.disabled = true;
    }
  },
  methods: {
    //   手机号回调
    tellhandle(e) {
      let value = e.target.value;
      if (this.$regulars.isPhone(value)) {
        this.status = 1;
        this.tell = value;
      }
    },
    //   验证码回调
    veryhandle(e) {
      if(this.tell){
        this.setError()
        this.very=e.target.value;
        this.checkVery().then(()=>{
          this.getResult()
        }).catch(err=>{
          if(err.data && err.data.errorMsg){
            return this.setError(err.data.errorMsg)
          }
          this.setError("短信验证码校验失败，请检查您输入的验证码是否有效")
        })
      }
    },
    checkVery(){
      let productBaseInfo = this.$store.state.productBaseInfo;
      let veryLoading=this.$notice.loading('正在为您匹配手机号和验证码真实性！');
      return new Promise((resolve, reject) => {
         this.$http({
            url: "/insure/insureProcess?step=TBS&insureUniqueId=" + productBaseInfo.insureUniqueId,
            data: {
              very: this.very,
              reqSn: this.params,
            }
          })
            .then(r => {
              this.$notice.close(veryLoading)
              resolve()
            })
            .catch(err => {
              console.log(err);
              this.$notice.close(veryLoading)
              reject(err)
            });
      })
    },
    getVery() {
      if (!this.tell) {
        return this.$notice.msg("请您先正确填写手机号！");
      }
      if (this.status == 1) {
        let productBaseInfo = this.$store.state.productBaseInfo;
        let bankInfo = this.$store.state.bankInfo
        this.$http({
            url: "/insure/insureProcess?step=TPS&insureUniqueId=" + productBaseInfo.insureUniqueId,
            data: {
              tell: this.tell,
              bank:bankInfo
            }
          })
            .then(r => {
              this.countDown(60);
              this.$notice.msg('验证码已发送，请注意查看您的手机短信！');
              this.params=r.data;
              this.hasSendVery=true;
            })
            .catch(err => {
              console.log(err);
            });
      }
    },
    countDown(number) {
      this.status = 2;
      this.veryTxt=number;
      this.timor = setInterval(()=> {
        number--
        console.log(number);
        if (number <1) {
          clearInterval(this.timor)
          this.veryTxt = "";
          this.status = 1;
          return;
        }
        this.veryTxt = number;
      }, 1000);
    },
    getResult() {
      //选择后回调到父组件
      let value = {
        tell: this.tell,
        very: this.very,//验证码
        params:this.params,//验证码携带的校验参数
      };
      this.selectData.elementValue = value;
    },
    setError(msg) {
      if (!msg) {
        return (this.selectData.errorMsg = "");
      }
      this.errMsg=msg
      this.selectData.errorMsg = msg;
    }
  }
};
</script>

<style lang="scss" scoped>
.items {
  .lables {
    width: 25%;
  }
  .items-wrap {
    padding: 3px 0;
  }
  .border {
    border-bottom: 1px solid #ececec;
  }
  .from-right {
    width: 74%;
  }
  .from-right {
    display: flex !important;
    flex-direction: row;
    justify-content: flex-start;
  }
  .veryNumber {
    width: 50%;
  }
  .veryTxt {
    display: inline-block;
    width: 45%;
    height: 60px;
    line-height: 60px;
    border-radius: 60px;
    background-color: #0084ff;
    color: #fff;
    text-align: center;
    font-size: 26px;
  }
  .status0,
  .status2 {
    background-color: #999;
    color: #fff;
  }
}
</style>
